import React from 'react';
import { Switch } from '@headlessui/react';
import { cn } from './cn';

/**
 * Toggle — công tắc bật/tắt (Headless UI Switch). Controlled: checked + onChange(bool).
 * size: 'sm' | 'base'
 */
export function Toggle({ checked, onChange, disabled = false, label, description, id, size = 'base', className }) {
  const dims =
    size === 'sm'
      ? { track: 'h-5 w-9', thumb: 'h-4 w-4', on: 'translate-x-4', off: 'translate-x-0.5' }
      : { track: 'h-6 w-11', thumb: 'h-5 w-5', on: 'translate-x-5', off: 'translate-x-0.5' };

  const sw = (
    <Switch
      checked={!!checked}
      onChange={onChange}
      disabled={disabled}
      id={id}
      className={cn(
        'relative inline-flex flex-shrink-0 items-center rounded-full transition-colors duration-200',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/50',
        dims.track,
        checked ? 'bg-brand' : 'bg-gray-300 dark:bg-gray-700',
        disabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block transform rounded-full bg-white shadow transition duration-200',
          dims.thumb,
          checked ? dims.on : dims.off
        )}
      />
    </Switch>
  );

  if (!label && !description) return sw;
  return (
    <div className={cn('flex items-center justify-between gap-4', className)}>
      <span className="min-w-0">
        {label ? <span className="block text-sm font-medium text-heading">{label}</span> : null}
        {description ? <span className="block text-xs text-muted mt-0.5">{description}</span> : null}
      </span>
      {sw}
    </div>
  );
}

export default Toggle;
